import useFilterRoutes from 'shared/hooks/useFilterRoutes'
import * as routes from 'src/constants/routes'

export function useRoutes() {
  return useFilterRoutes(routes)
}

export default useRoutes
